<!-- TODO: definire il testo -->
<app-toolkit-page-title title="Accessibilità"></app-toolkit-page-title>
<div class="row">
    <div class="col-sm-12">
        <article>Il sito ODS – OPERE DI DIFESA DEL SUOLO è stato sviluppato con l’obiettivo di offrire ai cittadini uno strumento completo, semplice, comprensibile e fruibile in ogni condizione. La prima imprescindibile qualità di un sito web pubblico è <strong>l’accessibilità</strong>, ossia la possibilità di accedere al sito indipendentemente da eventuali limitazioni tecnologiche, fisiche o ambientali. Altra caratteristica oggi considerata essenziale è la <strong>responsività</strong>, ossia la capacità del sito di adattarsi in modo automatico alla grandezza del dispositivo utilizzato dall’utente (computer, tablet o smartphone) risultando facile da leggere e da navigare.
            <br>
            <br>

            Il sito ODS – OPERE DI DIFESA DEL SUOLO garantisce il rispetto dei <strong>requisiti tecnici previsti nell’allegato A della Legge 4/2004</strong> "Disposizioni per favorire l'accesso dei soggetti disabili agli strumenti informatici" (cosiddetta Legge Stanca), ed è stato sviluppato con il linguaggio di marcatura HTML5 e fogli di stile CSS.
            
            La progettazione del sito si è svolta in varie fasi, ciascuna con momenti differenti di verifica della qualità, sia sotto l’aspetto dell’usabilità che dell’accessibilità. Ogni modello di pagina è quindi stato sottoposto a verifiche attraverso l’utilizzo di strumenti automatici di validazione e successivamente attraverso verifiche manuali.
            <br>
            <br>
            <strong>Strumenti automatici di validazione</strong>
            <br>
            <br>
            Tutte le pagine del sito sono state verificati con i seguenti strumenti automatici: 
            <br>
            <br>
            · Supporto automatico alla verifica di accessibilità tramite <a href="https://chrome.google.com/webstore/detail/axe-devtools-web-accessib/lhdoppojpmngadmnindnejefpokejbdd">axe DevTools</a>
            <br>
            <br>
            <strong>Altri Tools</strong>
            <br>
            <br>
            · <a href="https://chrome.google.com/webstore/detail/wcag-color-contrast-check/plnahcmalebffmaghcpcmpaciebdhgdf">Color contrast analyzer</a>
            <br>
            <br>
            
            <strong>Compatibilità sistemi operativi e browser</strong>
            <br>
            <br>
            Il sito è stato progettato e testato per garantire la massima compatibilità con i principali sistemi operativi e browser, sia dal punto di vista funzionale che di visualizzazione. Il sito è stato verificato quindi con:
            <br>
            <br>
            
            <strong>Browser</strong>
            <br>
            <br>
            
            · Chrome
            <br>
            <br>
            
            · Firefox
            <br>
            <br>
            
            · EDGE
            <br>
            <br>
            
            <strong>Sistemi operativi</strong>
            <br>
            <br>
            
            · Windows 11
            <br>
            <br>
            
            <strong>Test di usabilità</strong>
            <br>
            <br>

            
            Il servizio è stato progettato e implementato per rispettare i criteri di usabilità definiti da AGID (Linee guida di design servizi digitali della PA, Protocollo eGLU LG 2018.1 e s.m.i.).
            
            In particolare, la verifica è stata svolta da un panel di 6 utenti partecipanti ad un test con 7 task individuati.
            <br>
            <br>
            
            <strong>Obiettivi di accessibilità</strong>
            <br>
            <br>
            
            Ogni anno tutte le amministrazioni devono decidere e pubblicare i propri obiettivi per l’accessibilità informatica (Legge n. 179 del 18 ottobre 2012). <a href="https://www.regione.lombardia.it/wps/portal/istituzionale/HP/DettaglioAT/istituzione/amministrazione-trasparente/altri-contenuti/altri-contenuti-accessibilita-e-catalogo-di-dati-metadati-e-banche-dati/obiettivi-di-accessibilita/obiettivi-di-accessibilita">Consulta gli obiettivi di accessibilità di Regione Lombardia.</a>
            <br>
            <br>

        </article>
    </div>
</div>